import React from 'react';
import { Box, useTheme } from '@mui/material';
import Sidebar from '../Sidebar/Sidebar';

const FullScreenLayout = ({ children }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar />
      <Box 
        component="main" 
        sx={{
          flex: 1,
          height: '100vh',
          overflow: 'hidden',
          marginLeft: {
            xs: 0,
            md: '256px',
          },
          transition: theme.transitions.create(['margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default FullScreenLayout;
